import React, {ReactNode} from "react";
import PageAncestor from "core/common/page/pageAncestor";
import mdEntityService from "core/metamodel/mdEntityService";
import {MODULE, PageProps, PERMISSION} from "core/metamodel/metaConstant";
import {observer} from "mobx-react";
import {action, ObservableMap} from "mobx";
import MdEntity from "core/metamodel/mdEntity";
import {loc} from "core/common/config/locales";
import 'flag-icon-css/css/flag-icon.css';
import SbToolProjectVersionService from "../../service/projectVersionService";
import projectVersionService from "../../service/projectVersionService";
import {Criterion} from "../../domain/criterion/criterionDomain";
import ProjectVersionParamsForm from "../../component/parameter/projectVersionParamsForm";
import {ProjectVersion} from "../../domain/project/projectVersionDomain";
import Toolmenu from "../../../core/components/toolmenu/toolmenu";
import {SecuredZzUploadFlatButton, ZzFlatButton} from "../../../core/components/buttons/buttons";
import uiService from "../../../core/common/service/uiService";
import {IDomainObject, preSave} from "../../../core/form/formUtils";
import sbToolProjectService from "../../service/projectService";
import {ProjectCriterionVersion} from "../../domain/project/projectCriterionVersionDomain";
import Grid, {GridLocation, GridRow} from "../../../core/grid/domain/grid";
import GridComp, {UILOCATION} from "../../../core/grid/component/gridComp";
import {Tab, Tabs} from "material-ui";
import {TabTemplate} from "../../../core/common/config/mui-theme";
import gridService from "../../../core/grid/gridService";
import {MovingBlocks} from "../../../core/grid/gridUtils";
import {
  AREA_ENTITY,
  CRITERION_ENTITY,
  PROJECT_CRITERION_VERSION_ENTITY,
  PROJECT_VERSION_AREA_ENTITY,
  PROJECT_VERSION_DOOR_ENTITY,
  PROJECT_VERSION_ENERGY_CARRIER_ENTITY,
  PROJECT_VERSION_ENTITY,
  PROJECT_VERSION_MATERIAL_ENTITY,
  PROJECT_VERSION_PARAM_VALUE_ENTITY,
  PROJECT_VERSION_ROOM_ENTITY,
  PROJECT_VERSION_WINDOW_ENTITY,
  PROJECT_VERSION_TREE_ENTITY,
  SUB_CRITERION_ENTITY,
  SUB_CRITERION_PARAM_ENTITY,
  SUB_CRITERION_PARAM_VALUE_ENTITY,
  PROJECT_VERSION_LOP_FILLINGS_ENTITY,
  PROJECT_VERSION_LOP_PROFILES_ENTITY,
  PROJECT_VERSION_PARKING_ENTITY,
  PROJECT_VERSION_LIFESPAN_ENTITY,
  PROJECT_MATERIAL_ENTITY,
  PROJECT_RUNOFF_COEFFICIENT_ENTITY,
  PROJECT_VERSION_CAPACITIES_ENTITY
} from "../../entityConstants";
import {
  CRITERIA_LIST,
  PROJECT_VERSION_AREA_LIST,
  PROJECT_VERSION_DOOR_LIST,
  PROJECT_VERSION_ENERGY_CARRIERS_LIST,
  PROJECT_VERSION_MATERIALS_GRID,
  PROJECT_VERSION_ROOMS_LIST,
  PROJECT_VERSION_WINDOW_LIST,
  PROJECT_VERSION_TREE_LIST,
  PROJECT_VERSION_RECYCLABLE_MATERIALS_LIST,
  PROJECT_VERSION_EPD_CERTIFIED_MATERIALS_LIST,
  PROJECT_VERSION_WOOD_BASED_MATERIALS_GRID,
  PROJECT_VERSION_AREA_ZELPO_GRID,
  PROJECT_VERSION_AREA_ZELZP_GRID,
  PROJECT_VERSION_AREA_ZELZS_GRID,
  PROJECT_VERSION_AREA_ZELZF_GRID,
  PROJECT_VERSION_AREA_ZELST_GRID,
  PROJECT_VERSION_AREA_VPREP_GRID,
  PROJECT_VERSION_AREA_PEFKE_GRID,
  PROJECT_VERSION_LOP_FILLINGS_GRID,
  PROJECT_VERSION_LOP_PROFILES_GRID,
  PROJECT_VERSION_PARKING_GRID,
  LIFESPAN_LIST,
  PROJECT_MATERIAL_GRID,
  PROJECT_RUNOFF_COEFFICIENT_GRID,
  PROJECT_VERSION_CAPACITIES_GRID
} from "../../gridsContants";
import Form from "../../../core/form/form";
import {ProjectVersionMaterial} from "../../domain/project/projectVersionMaterialDomain";
import ProjectVersionMaterialForm, {
  ProjectVersionMaterialFormDefinition
} from "../../component/projectVersionMaterialForm";
import paramsService from "../../service/paramsService";
import ProjectVersionEnergyCarrierForm, {
  ProjectVersionEnergyCarrierFormDefinition
} from "../../component/projectVersionEnergyCarrierForm";
import ProjectVersionRoomForm, {ProjectVersionRoomFormDefinition} from "../../component/projectVersionRoomForm";
import {ProjectVersionRoom} from "../../domain/project/projectVersionRoomDomain";
import ConfirmationDialog from "../../../core/components/confirmationDialog/confirmationDialog";
import ProjectVersionAreaForm, {ProjectVersionAreaFormDefinition} from "../../component/projectVersionAreaForm";
import {ProjectVersionArea} from "../../domain/project/projectVersionAreaDomain";
import ProjectVersionDoor from "../../domain/project/projectVersionDoorDomain";
import ProjectVersionDoorForm, {ProjectVersionDoorFormDefinition} from "../../component/projectVersionDoorForm";
import ProjectVersionDoorMaterialExpandComp from "../../component/projectVersionDoorMaterialExpandComp";
import projectVersionDoorService from "../../service/projectVersionDoorService";
import ProjectVersionWindowForm, {ProjectVersionWindowFormDefinition} from "../../component/projectVersionWindowForm";
import ProjectVersionWindowExpandComp from "../../component/projectVersionWindowExpandComp";
import ProjectVersionLopMaterialExpandComp from "../../component/projectVersionLopMaterialExpandComp";
import {ProjectVersionWindow} from "../../domain/project/projectVersionWindowDomain";
import ProjectVersionLopFillingsForm, {
  ProjectVersionLopFillingsFormDefinition
} from "../../component/projectVersionLopFillingsForm";
import ProjectVersionTreeForm, {ProjectVersionTreeFormDefinition} from "../../component/projectVersionTreeForm";
import ProjectVersionTree from "../../domain/project/projectVersionTreeDomain";
import ProjectVersionLopFilling from "../../domain/project/projectVersionLopFillingDomain";
import ProjectVersionLopProfilesForm, {
  ProjectVersionLopProfilesFormDefinition
} from "../../component/projectVersionLopProfilesForm";
import ProjectVersionLopProfile from "../../domain/project/projectVersionLopProfileDomain";
import ProjectVersionParkingForm, {
  ProjectVersionParkingFormDefinition
} from "../../component/projectVersionParkingForm";
import ProjectVersionParking from "../../domain/project/projectVersionParkingDomain";
import {Project} from "../../domain/project/projectDomain";
import ProjectVersionLifespanForm, {
  ProjectVersionLifespanFormDefinition
} from "../../component/projectVersionLifespanForm";
import ProjectMaterialsForm from "../../component/projectMaterialsForm";
import ProjectRunoffCoefficientForm, {
  ProjectRunoffCoefficientFormDefinition
} from "../../component/projectRunoffCoefficientForm";
import ProjectVersionForm from "../../component/projectVersionForm";
import {PAGE} from "../../../routes";
import {uploadAxios} from "../../../core/common/config/axios-config";
import ProjectService from "../../service/projectService";
import {LoadingIcon} from "../../../core/components/common/loading";
import ProjectVersionCapacitiesForm, {
  ProjectVersionCapacitiesFormDefinition
} from "../../component/projectCapacitiesForm";
import {ProjectVersionEnergyCarrier} from "../../domain/project/projectVersionEnergyCarrierDomain";
import {ProjectVersionRunoffCoefficient} from "../../domain/project/projectRunoffCoefficientDomain";
import {ProjectVersionCapacity} from "../../domain/project/projectVersionCapacitiesDomain";

interface ProjectImportResponse {
  projectId?: number
  importErrors: string[]
}

const TabStyles = {
  height: 50,
  backgroundColor: '#F9F9F9',
  borderRadius: 5,
  boxShadow: " rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px"
}
const subTabsStyles = {
  backgroundColor: '#F9F9F9',
  borderRadius: 5,
  boxShadow: " rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px"
}
@observer
export default class ProjectVersionDetail extends PageAncestor<PageProps, any> {

  static module = MODULE.sbtool;
  static title = loc.i18n`Project version`;
  static icon = 'building-o';
  static protectedPage = true;

  private modalWindow: ConfirmationDialog

  constructor() {
    super();
    this.state = {
      isEnergyFormOpen: false,
      isRunoffCoefficientFormOpen: false,
      isMaterialsFormOpen: false,
      isRoomsFormOpen: false,
      isAreasFormOpen: false,
      isWindowsFormOpen: false,
      isDoorsFormOpen: false,
      isLopFillingsFormOpen: false,
      isLopProfilesFormOpen: false,
      isLopParkingFormOpen: false,
      isTreesFormOpen: false,
      isProjectInfoOpen: false,
      image: null,
      isImportingData: false,
      isImportingMaterials: false,
      isCapacitiesFormOpen: false,
      certificate: null
    };
  }

  static fetchData(routerParams, query) {
    console.log("ProjectVersionDetail#fetchData(%O)", query);

    let metadataPromise = mdEntityService.fetchEntityMetadata([
      PROJECT_VERSION_ENTITY,
      CRITERION_ENTITY,
      SUB_CRITERION_ENTITY,
      SUB_CRITERION_PARAM_ENTITY,
      SUB_CRITERION_PARAM_VALUE_ENTITY,
      PROJECT_CRITERION_VERSION_ENTITY,
      PROJECT_MATERIAL_ENTITY,
      PROJECT_VERSION_LIFESPAN_ENTITY,
      PROJECT_VERSION_ENERGY_CARRIER_ENTITY,
      PROJECT_VERSION_PARAM_VALUE_ENTITY,
      PROJECT_VERSION_ROOM_ENTITY,
      PROJECT_VERSION_AREA_ENTITY,
      AREA_ENTITY,
      PROJECT_VERSION_DOOR_ENTITY,
      PROJECT_VERSION_WINDOW_ENTITY,
      PROJECT_VERSION_TREE_ENTITY,
      PROJECT_VERSION_LOP_PROFILES_ENTITY,
      PROJECT_VERSION_LOP_FILLINGS_ENTITY,
      PROJECT_VERSION_PARKING_ENTITY,
      PROJECT_VERSION_MATERIAL_ENTITY,
      PROJECT_RUNOFF_COEFFICIENT_ENTITY,
      PROJECT_VERSION_CAPACITIES_ENTITY
    ]);

    let projectVersionPromise: Promise<ProjectVersion>;

    // Empty list of criterion versions, for case when project version is new
    let projectCriterionVersionPromise: Promise<ProjectCriterionVersion[]> = new Promise<ProjectCriterionVersion[]>((resolve => {
      resolve([])
    }));

    // Empty list of criteria, for case when project version is new
    let criteriaListPromise: Promise<Criterion[]> = new Promise<Criterion[]>((resolve => {
      resolve([])
    }));


    let gridPromise = gridService.fetchGrids(PROJECT_VERSION_MATERIALS_GRID,
      PROJECT_VERSION_ENERGY_CARRIERS_LIST,
      PROJECT_VERSION_ROOMS_LIST,
      PROJECT_VERSION_AREA_LIST,
      PROJECT_VERSION_DOOR_LIST,
      PROJECT_VERSION_WINDOW_LIST,
      PROJECT_VERSION_TREE_LIST,
      PROJECT_VERSION_RECYCLABLE_MATERIALS_LIST,
      PROJECT_VERSION_EPD_CERTIFIED_MATERIALS_LIST,
      PROJECT_VERSION_WOOD_BASED_MATERIALS_GRID,
      PROJECT_VERSION_AREA_ZELPO_GRID,
      PROJECT_VERSION_AREA_ZELZP_GRID,
      PROJECT_VERSION_AREA_ZELST_GRID,
      PROJECT_VERSION_AREA_ZELZS_GRID,
      PROJECT_VERSION_AREA_ZELZF_GRID,
      PROJECT_VERSION_AREA_VPREP_GRID,
      PROJECT_VERSION_AREA_PEFKE_GRID,
      PROJECT_VERSION_LOP_FILLINGS_GRID,
      PROJECT_VERSION_LOP_PROFILES_GRID,
      PROJECT_VERSION_PARKING_GRID,
      LIFESPAN_LIST,
      PROJECT_MATERIAL_GRID,
      PROJECT_RUNOFF_COEFFICIENT_GRID,
      PROJECT_VERSION_CAPACITIES_GRID
    );

    if (routerParams.id === 'new') {
      projectVersionPromise = Promise.resolve(new ProjectVersion(Object.assign({
        $new: true,
        active: true
      }, query)))
        .then(res => {
          return sbToolProjectService.readProject(query.projectId).then(project => {
            res.project = project
            return res;
          })
        });
    } else if (routerParams.id === 'copy') {
      projectVersionPromise = SbToolProjectVersionService.readProjectVersion(query.copyId)
        .then(projectVersion => {
          projectVersion.cleanOnCopy();
          projectVersion.active = true;
          return projectVersion;
        })
    } else {
      projectVersionPromise = SbToolProjectVersionService.readProjectVersion(routerParams.id)
      projectCriterionVersionPromise = SbToolProjectVersionService.readProjectCriteriaVersions(routerParams.id);
      criteriaListPromise = SbToolProjectVersionService.readProjectsVersionCriteria(routerParams.id)
    }


    return Promise.all([metadataPromise, projectVersionPromise, criteriaListPromise, projectCriterionVersionPromise, gridPromise])
      .then(([entityMap, projectVersion, criteria, criterionVersions, gridLocationMap]: [ObservableMap<MdEntity>, ProjectVersion, Criterion[], ProjectCriterionVersion[], ObservableMap<GridLocation>]) => {
        SbToolProjectVersionService.projectVersion = projectVersion;
        SbToolProjectVersionService.projectVersion = projectVersion.initAfterRead(routerParams.id === 'new');

        SbToolProjectVersionService.criteriaList.replace(criteria);
        SbToolProjectVersionService.criterionVersions.replace(criterionVersions);

        SbToolProjectVersionService.projectVersion.$movingBlocks = new MovingBlocks(PROJECT_VERSION_MATERIALS_GRID, true, query.tab,
          new Grid(gridLocationMap.get(PROJECT_VERSION_MATERIALS_GRID), SbToolProjectVersionService.projectVersion.versionId),
          new Grid(gridLocationMap.get(PROJECT_VERSION_ENERGY_CARRIERS_LIST), SbToolProjectVersionService.projectVersion.versionId),
          new Grid(gridLocationMap.get(PROJECT_VERSION_ROOMS_LIST), SbToolProjectVersionService.projectVersion.versionId),
          new Grid(gridLocationMap.get(PROJECT_VERSION_AREA_LIST), SbToolProjectVersionService.projectVersion.versionId),
          new Grid(gridLocationMap.get(PROJECT_VERSION_DOOR_LIST), SbToolProjectVersionService.projectVersion.versionId),
          new Grid(gridLocationMap.get(PROJECT_VERSION_WINDOW_LIST), SbToolProjectVersionService.projectVersion.versionId),
          new Grid(gridLocationMap.get(PROJECT_VERSION_TREE_LIST), SbToolProjectVersionService.projectVersion.versionId),
          new Grid(gridLocationMap.get(PROJECT_VERSION_RECYCLABLE_MATERIALS_LIST), SbToolProjectVersionService.projectVersion.versionId),
          new Grid(gridLocationMap.get(PROJECT_VERSION_EPD_CERTIFIED_MATERIALS_LIST), SbToolProjectVersionService.projectVersion.versionId),
          new Grid(gridLocationMap.get(PROJECT_VERSION_WOOD_BASED_MATERIALS_GRID), SbToolProjectVersionService.projectVersion.versionId),
          new Grid(gridLocationMap.get(PROJECT_VERSION_AREA_ZELPO_GRID), SbToolProjectVersionService.projectVersion.versionId),
          new Grid(gridLocationMap.get(PROJECT_VERSION_AREA_ZELZP_GRID), SbToolProjectVersionService.projectVersion.versionId),
          new Grid(gridLocationMap.get(PROJECT_VERSION_AREA_ZELST_GRID), SbToolProjectVersionService.projectVersion.versionId),
          new Grid(gridLocationMap.get(PROJECT_VERSION_AREA_ZELZF_GRID), SbToolProjectVersionService.projectVersion.versionId),
          new Grid(gridLocationMap.get(PROJECT_VERSION_AREA_ZELZS_GRID), SbToolProjectVersionService.projectVersion.versionId),
          new Grid(gridLocationMap.get(PROJECT_VERSION_AREA_VPREP_GRID), SbToolProjectVersionService.projectVersion.versionId),
          new Grid(gridLocationMap.get(PROJECT_VERSION_AREA_PEFKE_GRID), SbToolProjectVersionService.projectVersion.versionId),
          new Grid(gridLocationMap.get(PROJECT_VERSION_LOP_FILLINGS_GRID), SbToolProjectVersionService.projectVersion.versionId),
          new Grid(gridLocationMap.get(PROJECT_VERSION_LOP_PROFILES_GRID), SbToolProjectVersionService.projectVersion.versionId),
          new Grid(gridLocationMap.get(PROJECT_VERSION_PARKING_GRID), SbToolProjectVersionService.projectVersion.versionId),
          new Grid(gridLocationMap.get(LIFESPAN_LIST), SbToolProjectVersionService.projectVersion.versionId),
          new Grid(gridLocationMap.get(PROJECT_MATERIAL_GRID), SbToolProjectVersionService.projectVersion.versionId),
          new Grid(gridLocationMap.get(PROJECT_RUNOFF_COEFFICIENT_GRID), SbToolProjectVersionService.projectVersion.versionId),
          new Grid(gridLocationMap.get(PROJECT_VERSION_CAPACITIES_GRID), SbToolProjectVersionService.projectVersion.versionId)
        );
      })
  }

  componentDidMount() {
    SbToolProjectVersionService.projectVersion.$movingBlocks.blockArray.push()
    console.debug("%c componentDidMount", "background-color: magenta");
    SbToolProjectVersionService.projectVersion.$movingBlocks.blockArray.forEach((v) => {
      v.search(SbToolProjectVersionService.projectVersion, false)
    });
    let project: Project = SbToolProjectVersionService.projectVersion.project

    ProjectService.getProjectImage(project.projectId).then(res => {
      console.log('fetch Project Image')
      if (res) {
        this.setState({image: res})
      }
    })
    let projectVersionId = SbToolProjectVersionService.projectVersion.id;
    this.loadPDF(projectVersionId)
  }

  componentWillUnmount() {
    SbToolProjectVersionService.projectVersion = null;
    SbToolProjectVersionService.criterionVersions.clear();
    SbToolProjectVersionService.criteriaList.clear();
    SbToolProjectVersionService.criterionResults = null;
  }

  findRootObject() {
    return SbToolProjectVersionService.projectVersion;
  }

  // METHOD TABS
  private renderGlobalMaterialsTab = (): ReactNode => {
    let projectVersion: ProjectVersion = SbToolProjectVersionService.projectVersion;
    if (projectVersion.$new) {
      return <noscript/>
    }

    let propsForForm = {
      dataObject: SbToolProjectVersionService.projectVersion,
      rootObject: SbToolProjectVersionService.projectVersion,
      entity: mdEntityService.getEntity(PROJECT_MATERIAL_ENTITY),
      entities: mdEntityService.entityMap
    };

    const rowMaterialsForm = (
      <ProjectMaterialsForm {...propsForForm} />
    );


    let projectMaterialsGrid: Grid = projectVersion.$movingBlocks.getBlock(PROJECT_MATERIAL_GRID) as Grid;
    let projectMaterialTabContent = (
      <GridComp ref={PROJECT_MATERIAL_GRID}
                grid={projectMaterialsGrid}
                uiLocation={UILOCATION.tab}
                entities={mdEntityService.entityMap}
                hideGridConfig
                hideCopyRow
                rootObject={projectVersion}
                key={3.1}/>
    )

    return (<Tab label={loc.i18n`Materials`}
                 style={subTabsStyles}
                 key={PROJECT_MATERIAL_GRID}>
      {projectMaterialTabContent}
    </Tab>)
  }
  private renderLifespanTab = (): ReactNode => {
    let projectVersion: ProjectVersion = SbToolProjectVersionService.projectVersion;
    if (projectVersion.$new) {
      return <noscript/>
    }

    let propsForForm = {
      dataObject: SbToolProjectVersionService.projectVersion,
      rootObject: SbToolProjectVersionService.projectVersion,
      entity: mdEntityService.getEntity(PROJECT_VERSION_LIFESPAN_ENTITY),
      entities: mdEntityService.entityMap
    };

    const rowLifespanForm = (
      <ProjectVersionLifespanForm {...propsForForm} />
    );


    let lifespanGrid: Grid = projectVersion.$movingBlocks.getBlock(LIFESPAN_LIST) as Grid;
    let lifespanTabContent = (
      <GridComp ref={LIFESPAN_LIST}
                grid={lifespanGrid}
                uiLocation={UILOCATION.tab}
                editFormName={ProjectVersionLifespanFormDefinition.formName}
                entities={mdEntityService.entityMap}
                hideGridConfig
                hideCopyRow
                rootObject={projectVersion}
                key={2}/>
    )

    return (
      <Tab label={loc.i18n`Lifespan menu`} style={subTabsStyles} key={LIFESPAN_LIST}>
        {lifespanTabContent}
      </Tab>
    )
  }

  private renderEnergyCarriersTab = (): ReactNode => {
    let projectVersion: ProjectVersion = SbToolProjectVersionService.projectVersion;
    if (projectVersion.$new) {
      return <noscript/>
    }

    let propsForForm = {
      dataObject: SbToolProjectVersionService.projectVersion,
      rootObject: SbToolProjectVersionService.projectVersion,
      entity: mdEntityService.getEntity(PROJECT_VERSION_ENERGY_CARRIER_ENTITY),
      entities: mdEntityService.entityMap
    };


    const rowEnergyCarrierForm = (
      <ProjectVersionEnergyCarrierForm {...propsForForm}/>
    );

    let energyCarriersGrid: Grid = projectVersion.$movingBlocks.getBlock(PROJECT_VERSION_ENERGY_CARRIERS_LIST) as Grid;

    let energyCarriersTabContent = (
      <GridComp ref={PROJECT_VERSION_ENERGY_CARRIERS_LIST}
                grid={energyCarriersGrid}
                uiLocation={UILOCATION.tab}
                editFormName={ProjectVersionEnergyCarrierFormDefinition.formName}
                editForm={rowEnergyCarrierForm}
                entities={mdEntityService.entityMap}
                hideGridConfig
                hideCopyRow
                rootObject={projectVersion}
                editOverrideFn={this.addEnergyCarrierCallback}
                showDelete={true}
                showEdit={true}
                deleteRowIcon="fa fa-trash"
                key={2}>
        <ZzFlatButton onGridToolbar label={loc.i18n`New energy carrier`} permission={PERMISSION.New}
                      onClick={this.onAddEnergyCarrierClick}
                      disabled={this.state.isEnergyFormOpen}
        />
      </GridComp>
    )

    return (<Tab label={loc.i18n`Energy carriers`}
                 style={subTabsStyles}
                 key={PROJECT_VERSION_ENERGY_CARRIERS_LIST}>
      {energyCarriersTabContent}
    </Tab>)
  }
  @action onAddEnergyCarrierClick = () => {
    console.log('addNewEnergyCarrier');

    let materialsGrid: Grid = SbToolProjectVersionService.projectVersion.$movingBlocks.getBlock(PROJECT_VERSION_ENERGY_CARRIERS_LIST) as Grid;

    if (materialsGrid.getEditedRows().length > 0) {
      return;
    }

    let rowObject = new ProjectVersionEnergyCarrier({
      projectVersion: SbToolProjectVersionService.projectVersion.createLov(),
      $new: true,
      $dirty: true,
      $added: true,
    });

    materialsGrid.addFirstRow(rowObject);
    let form: Form<ProjectVersionEnergyCarrier> = rowObject.getForm(ProjectVersionEnergyCarrierFormDefinition.formName);
    this.setState({isEnergyFormOpen: true})
    form.$open = true;
  };
  @action addEnergyCarrierCallback = (rootObject: ProjectVersion, modifiedRows: GridRow[], toDeleteRows: GridRow[], params?: {
    [key: string]: any
  }): Promise<any> => {
    uiService.showToolbarActionFlag();
    let energyCarriersGrid: Grid = SbToolProjectVersionService.projectVersion.$movingBlocks.getBlock(PROJECT_VERSION_ENERGY_CARRIERS_LIST) as Grid;

    if (modifiedRows && modifiedRows.length === 1) {
      let energyCarrier = modifiedRows[0].rowObject as ProjectVersionEnergyCarrier;
      return projectVersionService.saveProjectVersionEnergyCarrier(rootObject.versionId, energyCarrier).then(resp => {
        SbToolProjectVersionService.projectVersion.$dirty = false;
        uiService.hideToolbarActionFlag();
        energyCarriersGrid.search(energyCarrier)
        paramsService.loadResults();
        paramsService.loadCriterionVersions()
        this.setState({isEnergyFormOpen: false})

      })
    }

    if (toDeleteRows && toDeleteRows.length === 1 && !toDeleteRows[0].rowObject.$added) {
      return projectVersionService.deleteProjectVersionEnergyCarrier(Number(toDeleteRows[0].rowObject.id)).then(resp => {
        SbToolProjectVersionService.projectVersion.$dirty = false;
        uiService.hideToolbarActionFlag();
        energyCarriersGrid.search(null)
        paramsService.loadResults();
        paramsService.loadCriterionVersions()

      })
    }
    SbToolProjectVersionService.projectVersion.$dirty = false;
    uiService.hideToolbarActionFlag();
    this.setState({isEnergyFormOpen: false})
    return energyCarriersGrid.search(null);
  };

  private renderRunoffCoefficientTab = (): ReactNode => {
    let projectVersion: ProjectVersion = SbToolProjectVersionService.projectVersion;
    if (projectVersion.$new) {
      return <noscript/>
    }

    let propsForForm = {
      dataObject: SbToolProjectVersionService.projectVersion,
      rootObject: SbToolProjectVersionService.projectVersion,
      entity: mdEntityService.getEntity(PROJECT_RUNOFF_COEFFICIENT_ENTITY),
      entities: mdEntityService.entityMap
    };

    const rowRunoffCoefficientForm = (
      <ProjectRunoffCoefficientForm {...propsForForm} />
    );


    let runoffGrid: Grid = projectVersion.$movingBlocks.getBlock(PROJECT_RUNOFF_COEFFICIENT_GRID) as Grid;
    let runoffCoefficientTabContent = (
      <GridComp ref={PROJECT_RUNOFF_COEFFICIENT_GRID}
                grid={runoffGrid}
                uiLocation={UILOCATION.tab}
                editFormName={ProjectRunoffCoefficientFormDefinition.formName}
                editForm={rowRunoffCoefficientForm}
                entities={mdEntityService.entityMap}
                hideGridConfig
                hideCopyRow
                rootObject={projectVersion}
                editOverrideFn={this.addRunoffCoefficientCallback}
                showDelete={true}
                showEdit={true}
                deleteRowIcon="fa fa-trash"
                key={2}>
        <ZzFlatButton onGridToolbar label={loc.i18n`New Runoff Coefficient`} permission={PERMISSION.New}
                      onClick={this.onAddRunoffCoefficientClick}
                      disabled={this.state.isRunoffCoefficientFormOpen}
        />
      </GridComp>
    )

    return (
      <Tab label={loc.i18n`TM Runoff coefficients`} style={subTabsStyles} key={PROJECT_RUNOFF_COEFFICIENT_GRID}>
        {runoffCoefficientTabContent}
      </Tab>
    )
  }
  @action onAddRunoffCoefficientClick = () => {
    console.log('AddRunoffCoefficient');

    let runoffCoefficientGrid: Grid = SbToolProjectVersionService.projectVersion.$movingBlocks.getBlock(PROJECT_RUNOFF_COEFFICIENT_GRID) as Grid;

    if (runoffCoefficientGrid.getEditedRows().length > 0) {
      return;
    }

    let rowObject = new ProjectVersionRunoffCoefficient({
      projectVersion: SbToolProjectVersionService.projectVersion.createLov(),
      $new: true,
      $dirty: true,
      $added: true,
    });

    runoffCoefficientGrid.addFirstRow(rowObject);
    let form: Form<ProjectVersionRunoffCoefficient> = rowObject.getForm(ProjectRunoffCoefficientFormDefinition.formName);
    this.setState({isRunoffCoefficientFormOpen: true})
    form.$open = true;
  };
  @action addRunoffCoefficientCallback = (rootObject: ProjectVersion, modifiedRows: GridRow[], toDeleteRows: GridRow[], params?: {
    [key: string]: any
  }): Promise<any> => {
    uiService.showToolbarActionFlag();
    let runoffCoefficientGrid: Grid = SbToolProjectVersionService.projectVersion.$movingBlocks.getBlock(PROJECT_RUNOFF_COEFFICIENT_GRID) as Grid;

    if (modifiedRows && modifiedRows.length === 1) {
      let runoffCoefficient = modifiedRows[0].rowObject as ProjectVersionRunoffCoefficient;
      return projectVersionService.saveProjectVersionRunoffCoefficient(rootObject.versionId, runoffCoefficient).then(resp => {
        SbToolProjectVersionService.projectVersion.$dirty = false;
        uiService.hideToolbarActionFlag();
        runoffCoefficientGrid.search(runoffCoefficient)
        paramsService.loadResults();
        paramsService.loadCriterionVersions()
        this.setState({isRunoffCoefficientFormOpen: false})

      })
    }

    if (toDeleteRows && toDeleteRows.length === 1 && !toDeleteRows[0].rowObject.$added) {
      return projectVersionService.deleteProjectVersionRunoffCoefficient(Number(toDeleteRows[0].rowObject.id)).then(resp => {
        SbToolProjectVersionService.projectVersion.$dirty = false;
        uiService.hideToolbarActionFlag();
        runoffCoefficientGrid.search(null)
        paramsService.loadResults();
        paramsService.loadCriterionVersions()
      })
    }
    SbToolProjectVersionService.projectVersion.$dirty = false;
    uiService.hideToolbarActionFlag();
    this.setState({isRunoffCoefficientFormOpen: false})
    return runoffCoefficientGrid.search(null);
  };


  // PROJECT TABS

  private renderCapacityTab = (): ReactNode => {
    let projectVersion: ProjectVersion = SbToolProjectVersionService.projectVersion;
    if (projectVersion.$new) {
      return <noscript/>
    }

    let propsForForm = {
      dataObject: SbToolProjectVersionService.projectVersion,
      rootObject: SbToolProjectVersionService.projectVersion,
      entity: mdEntityService.getEntity(PROJECT_VERSION_CAPACITIES_ENTITY),
      entities: mdEntityService.entityMap
    };

    const rowCapacitiesForm = (
      <ProjectVersionCapacitiesForm {...propsForForm} />
    );

    let capacitiesGrid: Grid = projectVersion.$movingBlocks.getBlock(PROJECT_VERSION_CAPACITIES_GRID) as Grid;
    let hasCapacity = capacitiesGrid.getTotalCount() > 0

    let capacitiesTabContent = (
      <GridComp ref={PROJECT_VERSION_CAPACITIES_GRID}
                grid={capacitiesGrid}
                uiLocation={UILOCATION.tab}
                editFormName={ProjectVersionCapacitiesFormDefinition.formName}
                editForm={rowCapacitiesForm}
                entities={mdEntityService.entityMap}
                hideGridConfig
                hideCopyRow
                rootObject={projectVersion}
                editOverrideFn={this.addCapacitiesCallback}
                showDelete={true}
                showEdit={true}
                deleteRowIcon="fa fa-trash"
                key={3}>
        <ZzFlatButton label={loc.i18n`nastavit kapacity`} permission={PERMISSION.New}
                      disabled={this.state.isCapacitiesFormOpen || hasCapacity}
                      onClick={this.onAddCapacitiesClick}
        />
      </GridComp>
    )

    return (<Tab label={loc.i18n`TP_01 Kapacity`}
                 style={subTabsStyles}
                 key={PROJECT_VERSION_CAPACITIES_GRID}>
      {capacitiesTabContent}
    </Tab>)

  }
  @action onAddCapacitiesClick = () => {
    console.log('addNewCapacity');
    let capacitiesGrid: Grid = SbToolProjectVersionService.projectVersion.$movingBlocks.getBlock(PROJECT_VERSION_CAPACITIES_GRID) as Grid;
    if (capacitiesGrid.data && capacitiesGrid.getEditedRows().length > 0) {
      return;
    }

    let rowObject = new ProjectVersionCapacity({
      projectVersion: SbToolProjectVersionService.projectVersion.createLov(),
      $new: true,
      $dirty: true,
      $added: true,
    });

    capacitiesGrid.addFirstRow(rowObject);
    let form: Form<ProjectVersionCapacity> = rowObject.getForm(ProjectVersionCapacitiesFormDefinition.formName);
    this.setState({isCapacitiesFormOpen: true})
    form.$open = true
  };
  @action addCapacitiesCallback = (rootObject: ProjectVersion, modifiedRows: GridRow[], toDeleteRows: GridRow[]): Promise<any> => {
    uiService.showToolbarActionFlag();
    const capacitiesGrid: Grid = SbToolProjectVersionService.projectVersion.$movingBlocks.getBlock(PROJECT_VERSION_CAPACITIES_GRID) as Grid;

    if (modifiedRows && modifiedRows.length === 1) {
      let capacity = modifiedRows[0].rowObject as ProjectVersionCapacity;
      return projectVersionService.saveProjectVersionIdentification(rootObject.versionId, capacity).then(() => {
        SbToolProjectVersionService.projectVersion.$dirty = false;
        uiService.hideToolbarActionFlag();
        capacitiesGrid.search(capacity);
        paramsService.loadResults();
        paramsService.loadCriterionVersions()
        this.setState({isCapacitiesFormOpen: false})
      })
    }

    if (toDeleteRows && toDeleteRows.length === 1 && !toDeleteRows[0].rowObject.$added) {
      return projectVersionService.deleteProjectVersionIdentification(Number(toDeleteRows[0].rowObject.id)).then(() => {
        SbToolProjectVersionService.projectVersion.$dirty = false;
        uiService.hideToolbarActionFlag();
        capacitiesGrid.search(null)
        paramsService.loadResults();
        paramsService.loadCriterionVersions()
      })
    }

    SbToolProjectVersionService.projectVersion.$dirty = false;
    uiService.hideToolbarActionFlag();
    this.setState({isCapacitiesFormOpen: false})
    return capacitiesGrid.search(null);
  };

  private renderMaterialsTab = (): ReactNode => {
    let projectVersion: ProjectVersion = SbToolProjectVersionService.projectVersion;
    if (projectVersion.$new) {
      return <noscript/>
    }

    let propsForForm = {
      dataObject: SbToolProjectVersionService.projectVersion,
      rootObject: SbToolProjectVersionService.projectVersion,
      entity: mdEntityService.getEntity(PROJECT_VERSION_MATERIAL_ENTITY),
      entities: mdEntityService.entityMap
    };

    const rowMaterialForm = (
      <ProjectVersionMaterialForm {...propsForForm} />
    );

    let materialsGrid: Grid = projectVersion.$movingBlocks.getBlock(PROJECT_VERSION_MATERIALS_GRID) as Grid;
    let materialTabContent = (
      <GridComp ref={PROJECT_VERSION_MATERIALS_GRID}
                grid={materialsGrid}
                uiLocation={UILOCATION.tab}
                editFormName={ProjectVersionMaterialFormDefinition.formName}
                editForm={rowMaterialForm}
                entities={mdEntityService.entityMap}
                hideGridConfig
                hideCopyRow
                rootObject={projectVersion}
                editOverrideFn={this.addMaterialCallback}
                showDelete={true}
                showEdit={true}
                deleteRowIcon="fa fa-trash"
                key={3}>
        <ZzFlatButton label={loc.i18n`New material`} permission={PERMISSION.New}
                      disabled={this.state.isMaterialsFormOpen}
                      onClick={this.onAddMaterialClick}
        />
      </GridComp>
    )

    return (<Tab label={loc.i18n`TP Materials`}
                 style={subTabsStyles}
                 key={PROJECT_VERSION_MATERIALS_GRID}>
      {materialTabContent}
    </Tab>)
  }
  @action onAddMaterialClick = () => {
    console.log('addNewMaterial');
    let materialsGrid: Grid = SbToolProjectVersionService.projectVersion.$movingBlocks.getBlock(PROJECT_VERSION_MATERIALS_GRID) as Grid;
    if (materialsGrid.data && materialsGrid.getEditedRows().length > 0) {
      return;
    }

    let rowObject = new ProjectVersionMaterial({
      projectVersion: SbToolProjectVersionService.projectVersion.createLov(),
      $new: true,
      $dirty: true,
      $added: true,
    });

    materialsGrid.addFirstRow(rowObject);
    let form: Form<ProjectVersionMaterial> = rowObject.getForm(ProjectVersionMaterialFormDefinition.formName);
    this.setState({isMaterialsFormOpen: true})
    form.$open = true
  };
  @action addMaterialCallback = (rootObject: ProjectVersion, modifiedRows: GridRow[], toDeleteRows: GridRow[]): Promise<any> => {
    uiService.showToolbarActionFlag();
    let materialsGrid: Grid = SbToolProjectVersionService.projectVersion.$movingBlocks.getBlock(PROJECT_VERSION_MATERIALS_GRID) as Grid;

    if (modifiedRows && modifiedRows.length === 1) {
      let material = modifiedRows[0].rowObject as ProjectVersionMaterial;
      material.thermalCoefficient = 0;
      material.code = "import";
      material.so2Equivalent = 0;
      material.c2h4Equivalent = 0;
      material.co2Equivalent = 0;
      material.po4Equivalent = 0;
      material.lifespan = 0;
      material.volume = 0;
      material.r11Equivalent = 0;
      material.area = 0;
      material.primaryEnergy = 0;
      return projectVersionService.saveProjectVersionMaterial(rootObject.versionId, material).then(() => {
        SbToolProjectVersionService.projectVersion.$dirty = false;
        uiService.hideToolbarActionFlag();
        materialsGrid.search(material)
        paramsService.loadResults();
        paramsService.loadCriterionVersions()
        this.setState({isMaterialsFormOpen: false})
      })
    }

    if (toDeleteRows && toDeleteRows.length === 1 && !toDeleteRows[0].rowObject.$added) {
      return projectVersionService.deleteProjectVersionMaterial(Number(toDeleteRows[0].rowObject.id)).then(() => {
        SbToolProjectVersionService.projectVersion.$dirty = false;
        uiService.hideToolbarActionFlag();
        materialsGrid.search(null)
        paramsService.loadResults();
        paramsService.loadCriterionVersions()
      })
    }
    SbToolProjectVersionService.projectVersion.$dirty = false;
    uiService.hideToolbarActionFlag();
    this.setState({isMaterialsFormOpen: false})
    return materialsGrid.search(null);
  };

  private renderRoomsTab = (): ReactNode => {
    let projectVersion: ProjectVersion = SbToolProjectVersionService.projectVersion;
    if (projectVersion.$new) {
      return <noscript/>
    }

    let propsForForm = {
      dataObject: SbToolProjectVersionService.projectVersion,
      rootObject: SbToolProjectVersionService.projectVersion,
      entity: mdEntityService.getEntity(PROJECT_VERSION_ROOM_ENTITY),
      entities: mdEntityService.entityMap
    };

    const rowRoomForm = (
      <ProjectVersionRoomForm {...propsForForm}/>
    );

    const roomsGrid: Grid = projectVersion.$movingBlocks.getBlock(PROJECT_VERSION_ROOMS_LIST) as Grid;

    const roomsTabContent = (
      <GridComp ref={PROJECT_VERSION_ROOMS_LIST}
                grid={roomsGrid}
                uiLocation={UILOCATION.tab}
                editFormName={ProjectVersionRoomFormDefinition.formName}
                editForm={rowRoomForm}
                entities={mdEntityService.entityMap}
                hideGridConfig
                hideCopyRow
                rootObject={projectVersion}
                editOverrideFn={this.addRoomCallback}
                showDelete={true}
                showEdit={true}
                deleteRowIcon="fa fa-trash"
                key={4}>
        <ZzFlatButton label={loc.i18n`New room`} permission={PERMISSION.New} disabled={this.state.isRoomsFormOpen}
                      onClick={this.onAddRoomClick}/>
      </GridComp>
    );

    return (<Tab label={loc.i18n`Rooms`}
                 style={subTabsStyles}
                 key={PROJECT_VERSION_ROOMS_LIST}>
      {roomsTabContent}
    </Tab>);
  };
  @action onAddRoomClick = () => {
    console.log('addNewProjectVersionRoom');
    let roomsGrid: Grid = SbToolProjectVersionService.projectVersion.$movingBlocks.getBlock(PROJECT_VERSION_ROOMS_LIST) as Grid;
    if (roomsGrid.data && roomsGrid.getEditedRows().length > 0) {
      return;
    }

    let rowObject = new ProjectVersionRoom({
      projectVersion: SbToolProjectVersionService.projectVersion.createLov(),
      $new: true,
      $dirty: true,
      $added: true,
    });
    roomsGrid.addFirstRow(rowObject);
    let form: Form<ProjectVersionRoom> = rowObject.getForm(ProjectVersionRoomFormDefinition.formName);
    this.setState({isRoomsFormOpen: true})
    form.$open = true;
  };
  @action addRoomCallback = (rootObject: ProjectVersion, modifiedRows: GridRow[], toDeleteRows: GridRow[]): Promise<any> => {
    uiService.showToolbarActionFlag();
    const roomsGrid: Grid = SbToolProjectVersionService.projectVersion.$movingBlocks.getBlock(PROJECT_VERSION_ROOMS_LIST) as Grid;

    if (modifiedRows && modifiedRows.length === 1) {
      let room = modifiedRows[0].rowObject as ProjectVersionRoom;
      return projectVersionService.saveProjectVersionRoom(rootObject.versionId, room).then(() => {
        SbToolProjectVersionService.projectVersion.$dirty = false;
        uiService.hideToolbarActionFlag();
        roomsGrid.search(room);
        paramsService.loadResults();
        paramsService.loadCriterionVersions()
        this.setState({isRoomsFormOpen: false})
      })
    }

    if (toDeleteRows && toDeleteRows.length === 1 && !toDeleteRows[0].rowObject.$added) {
      return projectVersionService.deleteProjectVersionRoom(Number(toDeleteRows[0].rowObject.id)).then(() => {
        SbToolProjectVersionService.projectVersion.$dirty = false;
        uiService.hideToolbarActionFlag();
        roomsGrid.search(null)
        paramsService.loadResults();
        paramsService.loadCriterionVersions()
      })
    }

    SbToolProjectVersionService.projectVersion.$dirty = false;
    uiService.hideToolbarActionFlag();
    this.setState({isRoomsFormOpen: false})
    return roomsGrid.search(null);
  };

  private renderAreasTab = (): ReactNode => {
    let projectVersion: ProjectVersion = SbToolProjectVersionService.projectVersion;
    if (projectVersion.$new) {
      return <noscript/>
    }

    let propsForForm = {
      dataObject: SbToolProjectVersionService.projectVersion,
      rootObject: SbToolProjectVersionService.projectVersion,
      entity: mdEntityService.getEntity(PROJECT_VERSION_AREA_ENTITY),
      entities: mdEntityService.entityMap
    };

    const areasGrid: Grid = projectVersion.$movingBlocks.getBlock(PROJECT_VERSION_AREA_LIST) as Grid;

    const rowAreaForm = (
      <ProjectVersionAreaForm {...propsForForm} />
    );

    const areasTabContent = (
      <GridComp ref={PROJECT_VERSION_AREA_LIST}
                grid={areasGrid}
                uiLocation={UILOCATION.tab}
                editFormName={ProjectVersionAreaFormDefinition.formName}
                editForm={rowAreaForm}
                entities={mdEntityService.entityMap}
                hideGridConfig
                hideCopyRow
                rootObject={projectVersion}
                editOverrideFn={this.addAreaCallback}
                showDelete={true}
                showEdit={true}
                deleteRowIcon="fa fa-trash"
                key={5}>
        <ZzFlatButton label={loc.i18n`New area`} permission={PERMISSION.New} disabled={this.state.isAreasFormOpen}
                      onClick={this.onAddAreaClick}/>
      </GridComp>
    );

    return (<Tab label={loc.i18n`Area`}
                 style={subTabsStyles}
                 key={PROJECT_VERSION_AREA_LIST}>
      {areasTabContent}
    </Tab>);

  };
  @action onAddAreaClick = () => {
    console.log('addNewArea');

    let areasGrid: Grid = SbToolProjectVersionService.projectVersion.$movingBlocks.getBlock(PROJECT_VERSION_AREA_LIST) as Grid;

    if (areasGrid.getEditedRows().length > 0) {
      return;
    }

    let rowObject = new ProjectVersionArea({
      projectVersion: SbToolProjectVersionService.projectVersion.createLov(),
      $new: true,
      $dirty: true,
      $added: true,
    });

    areasGrid.addFirstRow(rowObject);
    let form: Form<ProjectVersionArea> = rowObject.getForm(ProjectVersionAreaFormDefinition.formName);
    this.setState({isAreasFormOpen: true})
    form.$open = true;
  };
  @action addAreaCallback = (rootObject: ProjectVersion, modifiedRows: GridRow[], toDeleteRows: GridRow[]): Promise<any> => {
    uiService.showToolbarActionFlag();
    const areasGrid: Grid = SbToolProjectVersionService.projectVersion.$movingBlocks.getBlock(PROJECT_VERSION_AREA_LIST) as Grid;

    if (modifiedRows && modifiedRows.length === 1) {
      let area = modifiedRows[0].rowObject as ProjectVersionArea;
      return projectVersionService.saveProjectVersionArea(rootObject.versionId, area).then(() => {
        SbToolProjectVersionService.projectVersion.$dirty = false;
        uiService.hideToolbarActionFlag();
        areasGrid.search(area);
        paramsService.loadResults();
        paramsService.loadCriterionVersions()
        this.setState({isAreasFormOpen: false})
      })
    }

    if (toDeleteRows && toDeleteRows.length === 1 && !toDeleteRows[0].rowObject.$added) {
      return projectVersionService.deleteProjectVersionArea(Number(toDeleteRows[0].rowObject.id)).then(() => {
        SbToolProjectVersionService.projectVersion.$dirty = false;
        uiService.hideToolbarActionFlag();
        areasGrid.search(null)
        paramsService.loadResults();
        paramsService.loadCriterionVersions()
      })
    }

    SbToolProjectVersionService.projectVersion.$dirty = false;
    uiService.hideToolbarActionFlag();
    this.setState({isAreasFormOpen: false})
    return areasGrid.search(null);
  };

  private renderWindowsTab = (): ReactNode => {
    const veryImportantWindow = new ProjectVersionWindow({});
    let projectVersion: ProjectVersion = SbToolProjectVersionService.projectVersion;
    if (projectVersion.$new) {
      return <noscript/>
    }

    let propsForForm = {
      dataObject: SbToolProjectVersionService.projectVersion,
      rootObject: SbToolProjectVersionService.projectVersion,
      entity: mdEntityService.getEntity(PROJECT_VERSION_WINDOW_ENTITY),
      entities: mdEntityService.entityMap
    };


    const rowWindowForm = (
      <ProjectVersionWindowForm {...propsForForm}/>
    );

    let windowGrid: Grid = projectVersion.$movingBlocks.getBlock(PROJECT_VERSION_WINDOW_LIST) as Grid;

    let windowTamContent = (
      <GridComp ref={PROJECT_VERSION_WINDOW_LIST}
                grid={windowGrid}
                uiLocation={UILOCATION.tab}
                editFormName={ProjectVersionWindowFormDefinition.formName}
                editForm={rowWindowForm}
                editOverrideFn={this.addWindowCallback}
                entities={mdEntityService.entityMap}
                ExpandComponent={ProjectVersionWindowExpandComp}
                hideGridConfig
                hideCopyRow
                rootObject={projectVersion}
                showDelete={true}
                showEdit={true}
                showExpand={true}
                deleteRowIcon="fa fa-trash"
                key={6}>
        <ZzFlatButton onGridToolbar label={loc.i18n`New window`} permission={PERMISSION.New}
                      disabled={this.state.isWindowsFormOpen}
                      onClick={this.onAddWindowClick}/>
      </GridComp>
    )

    return (<Tab label={loc.i18n`Windows`}
                 style={subTabsStyles}
                 key={PROJECT_VERSION_WINDOW_LIST}>
      {windowTamContent}
    </Tab>)
  }
  @action onAddWindowClick = () => {
    console.log('onAddWindowClick');

    let materialsGrid: Grid = SbToolProjectVersionService.projectVersion.$movingBlocks.getBlock(PROJECT_VERSION_WINDOW_LIST) as Grid;

    if (materialsGrid.getEditedRows().length > 0) {
      return;
    }

    let rowObject = new ProjectVersionWindow({
      projectVersion: SbToolProjectVersionService.projectVersion.createLov(),
      $new: true,
      $dirty: true,
      $added: true,
    });

    materialsGrid.addFirstRow(rowObject);
    let form: Form<ProjectVersionWindow> = rowObject.getForm(ProjectVersionWindowFormDefinition.formName);
    this.setState({isWindowsFormOpen: true})
    form.$open = true;
  };
  @action addWindowCallback = (rootObject: ProjectVersion, modifiedRows: GridRow[], toDeleteRows: GridRow[]): Promise<any> => {
    uiService.showToolbarActionFlag();
    let grid: Grid = SbToolProjectVersionService.projectVersion.$movingBlocks.getBlock(PROJECT_VERSION_WINDOW_LIST) as Grid;

    if (modifiedRows && modifiedRows.length === 1) {
      let window = modifiedRows[0].rowObject as ProjectVersionWindow;
      return projectVersionService.saveProjectVersionWindow(rootObject.versionId, window).then(() => {
        SbToolProjectVersionService.projectVersion.$dirty = false;
        uiService.hideToolbarActionFlag();
        grid.search(window)
        paramsService.loadResults();
        paramsService.loadCriterionVersions()
        this.setState({isWindowsFormOpen: false})
      })
    }

    if (toDeleteRows && toDeleteRows.length === 1 && !toDeleteRows[0].rowObject.$added) {
      return projectVersionService.deleteProjectVersionWindow(Number(toDeleteRows[0].rowObject.id)).then(() => {
        SbToolProjectVersionService.projectVersion.$dirty = false;
        uiService.hideToolbarActionFlag();
        grid.search(null)
        paramsService.loadResults();
        paramsService.loadCriterionVersions()
      })
    }
    SbToolProjectVersionService.projectVersion.$dirty = false;
    uiService.hideToolbarActionFlag();
    this.setState({isWindowsFormOpen: false})
    return grid.search(null);
  };

  private renderDoorsTab = (): ReactNode => {
    let projectVersion: ProjectVersion = SbToolProjectVersionService.projectVersion;
    if (projectVersion.$new) {
      return <noscript/>
    }
    // Nemazat, nevim jak, ale bez toho to nefunguje
    let veryImportantDoor = new ProjectVersionDoor({});

    let propsForForm = {
      dataObject: SbToolProjectVersionService.projectVersion,
      rootObject: SbToolProjectVersionService.projectVersion,
      entity: mdEntityService.getEntity(PROJECT_VERSION_DOOR_ENTITY),
      entities: mdEntityService.entityMap
    };


    const rowDoorForm = (
      <ProjectVersionDoorForm {...propsForForm}/>
    );


    const doorsGrid: Grid = projectVersion.$movingBlocks.getBlock(PROJECT_VERSION_DOOR_LIST) as Grid;

    const doorsTabContent = (
      <GridComp ref={PROJECT_VERSION_DOOR_LIST}
                grid={doorsGrid}
                uiLocation={UILOCATION.tab}
                entities={mdEntityService.entityMap}
                editFormName={ProjectVersionDoorFormDefinition.formName}
                editForm={rowDoorForm}
                hideGridConfig
                hideCopyRow
                rootObject={projectVersion}
                showDelete={true}
                deleteRowIcon="fa fa-trash"
                showExpand={true}
                showEdit={true}
                editOverrideFn={this.addDoorCallback}
                ExpandComponent={ProjectVersionDoorMaterialExpandComp}
                key={7}>

        <ZzFlatButton label={loc.i18n`New door`} permission={PERMISSION.New} onClick={this.onAddDoorClick}
                      disabled={this.state.isDoorsFormOpen}/>
      </GridComp>);

    return (<Tab label={loc.i18n`Doors`}
                 style={subTabsStyles}
                 key={PROJECT_VERSION_DOOR_LIST}>
      {doorsTabContent}
    </Tab>);
  };
  @action addDoorCallback = (rootObject: ProjectVersion, modifiedRows: GridRow[], toDeleteRows: GridRow[]): Promise<any> => {
    uiService.showToolbarActionFlag();
    let doorGrid: Grid = SbToolProjectVersionService.projectVersion.$movingBlocks.getBlock(PROJECT_VERSION_DOOR_LIST) as Grid;

    if (modifiedRows && modifiedRows.length === 1) {
      let door = modifiedRows[0].rowObject as ProjectVersionDoor;
      return projectVersionDoorService.saveProjectVersionDoor(rootObject.versionId, door).then(() => {
        SbToolProjectVersionService.projectVersion.$dirty = false;
        uiService.hideToolbarActionFlag();
        doorGrid.search(door);
        paramsService.loadResults();
        paramsService.loadCriterionVersions()
        this.setState({isDoorsFormOpen: false})
      })
    }

    if (toDeleteRows && toDeleteRows.length === 1 && !toDeleteRows[0].rowObject.$added) {
      return projectVersionDoorService.deleteProjectVersionDoor(Number(toDeleteRows[0].rowObject.id)).then(() => {
        SbToolProjectVersionService.projectVersion.$dirty = false;
        uiService.hideToolbarActionFlag();
        doorGrid.search(null);
        paramsService.loadResults();
        paramsService.loadCriterionVersions()
      })
    }

    SbToolProjectVersionService.projectVersion.$dirty = false;
    uiService.hideToolbarActionFlag();
    this.setState({isDoorsFormOpen: false})
    return doorGrid.search(null);
  };
  @action onAddDoorClick = () => {
    console.log('addNewDoor');

    let doorGrid: Grid = SbToolProjectVersionService.projectVersion.$movingBlocks.getBlock(PROJECT_VERSION_DOOR_LIST) as Grid;

    if (doorGrid.getEditedRows().length > 0) {
      return;
    }

    let rowObject = new ProjectVersionDoor({
      projectVersion: SbToolProjectVersionService.projectVersion.createLov(),
      $new: true,
      $dirty: true,
      $added: true,
    });

    doorGrid.addFirstRow(rowObject);
    let form: Form<ProjectVersionDoor> = rowObject.getForm(ProjectVersionDoorFormDefinition.formName);
    this.setState({isDoorsFormOpen: true})
    form.$open = true;
  };

  private renderLopFillingTab = (): ReactNode => {
    let projectVersion: ProjectVersion = SbToolProjectVersionService.projectVersion;
    if (projectVersion.$new) {
      return <noscript/>
    }

    let propsForForm = {
      dataObject: SbToolProjectVersionService.projectVersion,
      rootObject: SbToolProjectVersionService.projectVersion,
      entity: mdEntityService.getEntity(PROJECT_VERSION_LOP_FILLINGS_ENTITY),
      entities: mdEntityService.entityMap
    };

    const rowLopFillingForm = (
      <ProjectVersionLopFillingsForm {...propsForForm} />
    );

    let lopFillingsGrid: Grid = projectVersion.$movingBlocks.getBlock(PROJECT_VERSION_LOP_FILLINGS_GRID) as Grid;

    let lopFillingsTabContent = (
      <GridComp ref={PROJECT_VERSION_LOP_FILLINGS_GRID}
                grid={lopFillingsGrid}
                uiLocation={UILOCATION.tab}
                editFormName={ProjectVersionLopFillingsFormDefinition.formName}
                editForm={rowLopFillingForm}
                entities={mdEntityService.entityMap}
                hideGridConfig
                hideCopyRow
                rootObject={projectVersion}
                editOverrideFn={this.addLopFillingsCallback}
                showDelete={true}
                showExpand={true}
                showEdit={true}
                deleteRowIcon="fa fa-trash"
                key={8}>
        <ZzFlatButton label={loc.i18n`New LOP`} permission={PERMISSION.New} disabled={this.state.isLopFillingsFormOpen}
                      onClick={this.onAddLopFillingsClick}
        />
      </GridComp>
    );

    return (<Tab label={loc.i18n`Lop Fillings`}
                 style={subTabsStyles}
                 key={PROJECT_VERSION_LOP_FILLINGS_GRID}>
      {lopFillingsTabContent}
    </Tab>)
  };
  @action addLopFillingsCallback = (rootObject: ProjectVersion, modifiedRows: GridRow[], toDeleteRows: GridRow[]): Promise<any> => {
    uiService.showToolbarActionFlag();
    let grid: Grid = SbToolProjectVersionService.projectVersion.$movingBlocks.getBlock(PROJECT_VERSION_LOP_FILLINGS_GRID) as Grid;

    if (modifiedRows && modifiedRows.length === 1) {
      let lop = modifiedRows[0].rowObject as ProjectVersionLopFilling;
      return projectVersionService.saveProjectVersionLopsFillings(rootObject.versionId, lop).then(() => {
        SbToolProjectVersionService.projectVersion.$dirty = false;
        uiService.hideToolbarActionFlag();
        grid.search(lop)
        paramsService.loadResults();
        paramsService.loadCriterionVersions()
        this.setState({isLopFillingsFormOpen: false})
      })
    }

    if (toDeleteRows && toDeleteRows.length === 1 && !toDeleteRows[0].rowObject.$added) {
      return projectVersionService.deleteProjectVersionLopsFillings(Number(toDeleteRows[0].rowObject.id)).then(() => {
        SbToolProjectVersionService.projectVersion.$dirty = false;
        uiService.hideToolbarActionFlag();
        grid.search(null)
        paramsService.loadResults();
        paramsService.loadCriterionVersions()
      })
    }
    SbToolProjectVersionService.projectVersion.$dirty = false;
    uiService.hideToolbarActionFlag();
    this.setState({isLopFillingsFormOpen: false})
    return grid.search(null);
  };
  @action onAddLopFillingsClick = () => {

    let lopFillingsGrid: Grid = SbToolProjectVersionService.projectVersion.$movingBlocks.getBlock(PROJECT_VERSION_LOP_FILLINGS_GRID) as Grid;
    if (lopFillingsGrid.getEditedRows().length > 0) {
      return;
    }

    let rowObject = new ProjectVersionLopFilling({
      projectVersion: SbToolProjectVersionService.projectVersion.createLov(),
      $new: true,
      $dirty: true,
      $added: true,
    });

    lopFillingsGrid.addFirstRow(rowObject);
    let form: Form<ProjectVersionLopFilling> = rowObject.getForm(ProjectVersionLopFillingsFormDefinition.formName);
    this.setState({isLopFillingsFormOpen: true})
    form.$open = true;
  };

  private renderLopsProfilesTab = (): ReactNode => {
    let projectVersion: ProjectVersion = SbToolProjectVersionService.projectVersion;
    if (projectVersion.$new) {
      return <noscript/>
    }

    let propsForForm = {
      dataObject: SbToolProjectVersionService.projectVersion,
      rootObject: SbToolProjectVersionService.projectVersion,
      entity: mdEntityService.getEntity(PROJECT_VERSION_LOP_PROFILES_ENTITY),
      entities: mdEntityService.entityMap
    };
    const rowLopForm = (
      <ProjectVersionLopProfilesForm {...propsForForm} />
    );
    let lopProfilesGrid: Grid = projectVersion.$movingBlocks.getBlock(PROJECT_VERSION_LOP_PROFILES_GRID) as Grid;
    let lopProfilesTabContent = (
      <GridComp ref={PROJECT_VERSION_LOP_PROFILES_GRID}
                grid={lopProfilesGrid}
                uiLocation={UILOCATION.tab}
                editFormName={ProjectVersionLopProfilesFormDefinition.formName}
                editForm={rowLopForm}
                entities={mdEntityService.entityMap}
                rootObject={projectVersion}
                editOverrideFn={this.addLopProfilesCallback}
                showDelete={true}
                showExpand={true}
                showEdit={true}
                deleteRowIcon="fa fa-trash"
                ExpandComponent={ProjectVersionLopMaterialExpandComp}
                key={9}>
        <ZzFlatButton label={loc.i18n`New LOP`} permission={PERMISSION.New} disabled={this.state.isLopProfilesFormOpen}
                      onClick={this.onAddLopProfilesClick}
        />
      </GridComp>
    );

    return (<Tab label={loc.i18n`Lop Profiles`}
                 style={subTabsStyles}
                 key={PROJECT_VERSION_LOP_PROFILES_GRID}>
      {lopProfilesTabContent}
    </Tab>)
  };
  @action addLopProfilesCallback = (rootObject: ProjectVersion, modifiedRows: GridRow[], toDeleteRows: GridRow[]): Promise<any> => {
    uiService.showToolbarActionFlag();
    let grid: Grid = SbToolProjectVersionService.projectVersion.$movingBlocks.getBlock(PROJECT_VERSION_LOP_PROFILES_GRID) as Grid;

    if (modifiedRows && modifiedRows.length === 1) {
      let lopProfiles = modifiedRows[0].rowObject as ProjectVersionLopProfile;
      console.log("SENDING DATA FROM LOP PROFILES", lopProfiles);
      return projectVersionService.saveProjectVersionLopsProfiles(rootObject.versionId, lopProfiles).then(() => {
        SbToolProjectVersionService.projectVersion.$dirty = false;
        uiService.hideToolbarActionFlag();
        grid.search(lopProfiles)
        paramsService.loadResults();
        paramsService.loadCriterionVersions()
        this.setState({isLopProfilesFormOpen: false})
      })
    }

    if (toDeleteRows && toDeleteRows.length === 1 && !toDeleteRows[0].rowObject.$added) {
      return projectVersionService.deleteProjectVersionLopsProfiles(Number(toDeleteRows[0].rowObject.id)).then(() => {
        SbToolProjectVersionService.projectVersion.$dirty = false;
        uiService.hideToolbarActionFlag();
        grid.search(null)
        paramsService.loadResults();
        paramsService.loadCriterionVersions()
      })
    }
    SbToolProjectVersionService.projectVersion.$dirty = false;
    uiService.hideToolbarActionFlag();
    this.setState({isLopProfilesFormOpen: false})
    return grid.search(null);
  };
  @action onAddLopProfilesClick = () => {

    let lopProfilesGrid: Grid = SbToolProjectVersionService.projectVersion.$movingBlocks.getBlock(PROJECT_VERSION_LOP_PROFILES_GRID) as Grid;
    if (lopProfilesGrid.getEditedRows().length > 0) {
      return;
    }

    let rowObject = new ProjectVersionLopProfile({
      projectVersion: SbToolProjectVersionService.projectVersion.createLov(),
      $new: true,
      $dirty: true,
      $added: true,
    });

    lopProfilesGrid.addFirstRow(rowObject);
    let form: Form<ProjectVersionLopProfile> = rowObject.getForm(ProjectVersionLopProfilesFormDefinition.formName);
    this.setState({isLopProfilesFormOpen: true})
    form.$open = true;
  };

  private renderParkingTab = (): ReactNode => {
    let projectVersion: ProjectVersion = SbToolProjectVersionService.projectVersion;
    if (projectVersion.$new) {
      return <noscript/>
    }

    let propsForForm = {
      dataObject: SbToolProjectVersionService.projectVersion,
      rootObject: SbToolProjectVersionService.projectVersion,
      entity: mdEntityService.getEntity(PROJECT_VERSION_PARKING_ENTITY),
      entities: mdEntityService.entityMap
    };
    const rowLopForm = (
      <ProjectVersionParkingForm {...propsForForm} />
    );
    let parkingGrid: Grid = projectVersion.$movingBlocks.getBlock(PROJECT_VERSION_PARKING_GRID) as Grid;
    let parkingTabContent = (
      <GridComp ref={PROJECT_VERSION_PARKING_GRID}
                grid={parkingGrid}
                uiLocation={UILOCATION.tab}
                editFormName={ProjectVersionParkingFormDefinition.formName}
                editForm={rowLopForm}
                entities={mdEntityService.entityMap}
                rootObject={projectVersion}
                editOverrideFn={this.addParkingCallback}
                showDelete={true}
                showExpand={true}
                showEdit={true}
                deleteRowIcon="fa fa-trash"
                key={10}>
        <ZzFlatButton label={loc.i18n`New Parking`} permission={PERMISSION.New} disabled={this.state.isParkingFormOpen}
                      onClick={this.onAddParkingClick}
        />
      </GridComp>
    );

    return (<Tab label={loc.i18n`Parking`}
                 style={subTabsStyles}
                 key={PROJECT_VERSION_PARKING_GRID}>
      {parkingTabContent}
    </Tab>)
  };
  @action addParkingCallback = (rootObject: ProjectVersion, modifiedRows: GridRow[], toDeleteRows: GridRow[]): Promise<any> => {
    uiService.showToolbarActionFlag();
    let grid: Grid = SbToolProjectVersionService.projectVersion.$movingBlocks.getBlock(PROJECT_VERSION_PARKING_GRID) as Grid;

    if (modifiedRows && modifiedRows.length === 1) {
      let parking = modifiedRows[0].rowObject as ProjectVersionParking;
      return projectVersionService.saveProjectVersionParking(rootObject.versionId, parking).then(() => {
        SbToolProjectVersionService.projectVersion.$dirty = false;
        uiService.hideToolbarActionFlag();
        grid.search(parking)
        paramsService.loadResults();
        paramsService.loadCriterionVersions()
        this.setState({isLopParkingFormOpen: false})
      })
    }

    if (toDeleteRows && toDeleteRows.length === 1 && !toDeleteRows[0].rowObject.$added) {
      return projectVersionService.deleteProjectVersionParking(Number(toDeleteRows[0].rowObject.id)).then(() => {
        SbToolProjectVersionService.projectVersion.$dirty = false;
        uiService.hideToolbarActionFlag();
        grid.search(null)
        paramsService.loadResults();
        paramsService.loadCriterionVersions()
      })
    }
    SbToolProjectVersionService.projectVersion.$dirty = false;
    uiService.hideToolbarActionFlag();
    this.setState({isLopParkingFormOpen: false})
    return grid.search(null);
  };
  @action onAddParkingClick = () => {

    let parkingGrid: Grid = SbToolProjectVersionService.projectVersion.$movingBlocks.getBlock(PROJECT_VERSION_PARKING_GRID) as Grid;
    if (parkingGrid.getEditedRows().length > 0) {
      return;
    }

    let rowObject = new ProjectVersionParking({
      projectVersion: SbToolProjectVersionService.projectVersion.createLov(),
      $new: true,
      $dirty: true,
      $added: true,
    });

    parkingGrid.addFirstRow(rowObject);
    let form: Form<ProjectVersionParking> = rowObject.getForm(ProjectVersionParkingFormDefinition.formName);
    this.setState({isLopParkingFormOpen: true})
    form.$open = true;
  };

  private renderTreesTab = (): ReactNode => {
    let projectVersion: ProjectVersion = SbToolProjectVersionService.projectVersion;
    if (projectVersion.$new) {
      return <noscript/>
    }

    let propsForForm = {
      dataObject: SbToolProjectVersionService.projectVersion,
      rootObject: SbToolProjectVersionService.projectVersion,
      entity: mdEntityService.getEntity(PROJECT_VERSION_TREE_ENTITY),
      entities: mdEntityService.entityMap
    };

    const rowTreeForm = (
      <ProjectVersionTreeForm {...propsForForm} />
    );

    let treesGrid: Grid = projectVersion.$movingBlocks.getBlock(PROJECT_VERSION_TREE_LIST) as Grid;
    let treesTabContent = (
      <GridComp ref={PROJECT_VERSION_TREE_LIST}
                grid={treesGrid}
                uiLocation={UILOCATION.tab}
                editFormName={ProjectVersionTreeFormDefinition.formName}
                editForm={rowTreeForm}
                entities={mdEntityService.entityMap}
                hideGridConfig
                hideCopyRow
                rootObject={projectVersion}
                editOverrideFn={this.addTreeCallback}
                showDelete={true}
                showEdit={true}
                deleteRowIcon="fa fa-trash"
                key={11}>
        <ZzFlatButton label={loc.i18n`New tree`} permission={PERMISSION.New} disabled={this.state.isTreesFormOpen}
                      onClick={this.onAddTreeClick}/>
      </GridComp>
    );

    return (<Tab label={loc.i18n`Trees`}
                 style={subTabsStyles}
                 key={PROJECT_VERSION_TREE_LIST}>
      {treesTabContent}
    </Tab>)
  };
  @action private addTreeCallback = (rootObject: ProjectVersion, modifiedRows: GridRow[], toDeleteRows: GridRow[]): Promise<any> => {
    uiService.showToolbarActionFlag();
    let grid: Grid = SbToolProjectVersionService.projectVersion.$movingBlocks.getBlock(PROJECT_VERSION_TREE_LIST) as Grid;

    if (modifiedRows && modifiedRows.length === 1) {
      let tree = modifiedRows[0].rowObject as ProjectVersionTree;
      return projectVersionService.saveProjectVersionTree(rootObject.versionId, tree).then(() => {
        SbToolProjectVersionService.projectVersion.$dirty = false;
        uiService.hideToolbarActionFlag();
        grid.search(tree)
        paramsService.loadResults();
        paramsService.loadCriterionVersions()
        this.setState({isTreesFormOpen: false})
      })
    }

    if (toDeleteRows && toDeleteRows.length === 1 && !toDeleteRows[0].rowObject.$added) {
      return projectVersionService.deleteProjectVersionTree(Number(toDeleteRows[0].rowObject.id)).then(() => {
        SbToolProjectVersionService.projectVersion.$dirty = false;
        uiService.hideToolbarActionFlag();
        grid.search(null)
        paramsService.loadResults();
        paramsService.loadCriterionVersions()
      })
    }
    SbToolProjectVersionService.projectVersion.$dirty = false;
    uiService.hideToolbarActionFlag();
    this.setState({isTreesFormOpen: false})
    return grid.search(null);
  };
  @action private onAddTreeClick = () => {
    console.log('addNewTree');

    let treesGrid: Grid = SbToolProjectVersionService.projectVersion.$movingBlocks.getBlock(PROJECT_VERSION_TREE_LIST) as Grid;
    if (treesGrid.getEditedRows().length > 0) {
      return;
    }

    let rowObject = new ProjectVersionTree({
      projectVersion: SbToolProjectVersionService.projectVersion.createLov(),
      $new: true,
      $dirty: true,
      $added: true,
    });

    treesGrid.addFirstRow(rowObject);
    let form: Form<ProjectVersionTree> = rowObject.getForm(ProjectVersionTreeFormDefinition.formName);
    this.setState({isTreesFormOpen: true})
    form.$open = true;
  };

  private renderProjectVersionForm = (): ReactNode => {
    let propsForCreateForm = {
      dataObject: SbToolProjectVersionService.projectVersion,
      rootObject: SbToolProjectVersionService.projectVersion,
      entity: mdEntityService.getEntity(PROJECT_VERSION_ENTITY),
      entities: mdEntityService.entityMap
    };

    return (
      <form style={{borderBottom: "1px solid #e7e7e7", marginBottom: 2}}>
        <ProjectVersionForm {...propsForCreateForm} key={1}/>
      </form>
    );
  }
  @action onSaveProjectVersion = () => {
    console.log('onSave ');
    uiService.showToolbarActionFlag();

    let result = preSave(SbToolProjectVersionService.projectVersion);
    if (!result) {
      return;
    }

    let promise: Promise<IDomainObject>;
    let copyId = this.props.query.copyId

    if (SbToolProjectVersionService.projectVersion.$new && this.props.query.copyId) {
      console.info("Copying project version with params")
      promise = SbToolProjectVersionService.copyProjectVersion(copyId, SbToolProjectVersionService.projectVersion)
    } else {
      console.info("Saving new project version")
      promise = SbToolProjectVersionService.saveProjectVersion(SbToolProjectVersionService.projectVersion);
    }

    promise.then(action("saveProjectVersion-action", (domainObject: IDomainObject) => {

      let wasNew = SbToolProjectVersionService.projectVersion.cleanAfterSave(domainObject, true);

      if (wasNew) {
        this.context.router.replaceWith('sbToolProjectVersionDetail', {id: SbToolProjectVersionService.projectVersion.versionId});
        // TODO: initiate fetch data without page reload
        window.location.reload(); // TODO : REMOVE IT
      }
      uiService.hideToolbarActionFlag();
    }), error => {
      SbToolProjectVersionService.projectVersion.$errors = error.getMessages();
    });
  }
  @action onCopyProjectVersion = () => {
    console.log('onCopy');
    this.context.router.transitionTo("sbToolProjectVersionDetail", {id: 'copy'}, {copyId: SbToolProjectVersionService.projectVersion.id});
  };
  @action onDeleteProjectVersion = () => {
    let projectVersion: ProjectVersion = SbToolProjectVersionService.projectVersion;
    SbToolProjectVersionService.deleteProjectVersion(projectVersion.versionId)
      .then(() => {
        this.context.router.transitionTo("sbToolProjectDetail", {id: projectVersion.project.projectId});
      }, error => {
        SbToolProjectVersionService.projectVersion.$errors = error.getMessages();
      });
  }
  handleDeleteVersion = () => {
    this.modalWindow.open(() => {
        this.onDeleteProjectVersion()
      },
      () => {
        return
      },
      'Chcete verzi vymazat? (Tuto akci nelze zastavit. Data budou trvale vymazána)')
  }
  private renderToolTipMenu = (): ReactNode => {
    let {query} = this.props;
    let projectVersion: ProjectVersion = SbToolProjectVersionService.projectVersion;
    let greenButtonStyle = {
      backgroundColor: projectVersion.$dirty ? 'PaleGreen' : ''
    }
    return (
      <Toolmenu chainGridLocation={query.gridLocation} backAction={this.onBack} backDisabled={History.length <= 1}
                historize entityName={PROJECT_VERSION_ENTITY}
                entityId={projectVersion.versionId}>
        <ZzFlatButton onClick={this.onSaveProjectVersion} disabled={!projectVersion.$dirty}
                      label={loc.i18n`Save Version`}
                      permission={projectVersion.$new ? PERMISSION.New : PERMISSION.Update}
                      style={greenButtonStyle}/>
        <ZzFlatButton onClick={this.onCopyProjectVersion} disabled={projectVersion.$new} label={loc.i18n`Copy Version`}
                      permission={PERMISSION.New}/>
        <ZzFlatButton onClick={this.handleDeleteVersion} disabled={projectVersion.$new}
                      label={loc.i18n`Delete Version`}
                      permission={PERMISSION.Delete}/>
        {this.state.certificate ?
          <ZzFlatButton onClick={this.downloadPDF}
                        label={loc.i18n`download certificate`}/>
          :
          <ZzFlatButton onClick={this.handleGenerateCertificate}
                        label={loc.i18n`vygenerovat certifikát`}/>
        }
        <ZzFlatButton onClick={() => this.setState({isProjectInfoOpen: !this.state.isProjectInfoOpen})}
                      label={!this.state.isProjectInfoOpen ? (loc.i18n`Otevřít informace o projektu`) : (loc.i18n`Zavřít informace o projektu`)}/>
        <SecuredZzUploadFlatButton label={loc.i18n`Importovat materiály projektu`} permission={PERMISSION.New}
                                   securable={PAGE.sbToolProjectDetail}
                                   handleFileUpload={this.handleUploadMaterials} accept=".xlsx, .xls"/>
        <SecuredZzUploadFlatButton label={loc.i18n`importovat data projektu`} permission={PERMISSION.New}
                                   securable={PAGE.sbToolProjectDetail}
                                   handleFileUpload={this.handleFileProjectData} accept=".xlsx, .xls"/>
        <SecuredZzUploadFlatButton
          label={this.state.image ? (loc.i18n`nahrát nove foto projektu`) : (loc.i18n`nahrát foto projektu`)}
          permission={PERMISSION.New}
          securable={PAGE.sbToolProjectDetail}
          handleFileUpload={this.handleUploadProjectImage} accept=".jpeg, .jpg"/>
      </Toolmenu>
    );
  }
  @action handleUploadMaterials = (files: FileList) => {
    this.setState({isImportingMaterials: true})
    let projectVersionId = SbToolProjectVersionService.projectVersion.id
    let data = new FormData();
    data.append("file", files.item(0), files.item(0).name);
    return uploadAxios.post(`/sbtool/project-version/${projectVersionId}/import`, data, {showPrettyError: true})
      .then(resp => {
        let importRes: ProjectImportResponse = resp.data as ProjectImportResponse;
        this.setState({isImportingMaterials: false})
        if (importRes.importErrors.length === 0) {
          // TODO: initiate fetch data without page reload
          window.location.reload()
          return
        }

      }).catch(e => {
        console.error("error while import project materials--->", e)
      })
  };
  @action handleFileProjectData = (files: FileList) => {
    this.setState({isImportingData: true})
    let projectVersionId = SbToolProjectVersionService.projectVersion.id
    let data = new FormData();
    data.append("file", files.item(0), files.item(0).name);
    return uploadAxios.post(`/sbtool/project-version/${projectVersionId}/import-project`, data, {showPrettyError: true})
      .then(resp => {
        let importRes: ProjectImportResponse = resp.data as ProjectImportResponse;
        this.setState({isImportingData: false})
        if (importRes.importErrors.length === 0) {
          // TODO: initiate fetch data without page reload
          window.location.reload()
          return
        }
      }).catch(e => {
        console.error("error while import project materials--->", e)
      })
  };
  @action handleGenerateCertificate = () => {
    this.modalWindow.open(() => {
        let projectVersionId = SbToolProjectVersionService.projectVersion.versionId
        SbToolProjectVersionService.finishProject(projectVersionId)
          .then(resp => console.warn('handleGenerateCertificate resp', resp))
          .then(() => this.loadPDF(projectVersionId))
          .catch(error => console.error(error))

      },
      () => {
        return
      }, 'Chcete vygenerovat certifikát? Po vygenerování nelze verzi projektu změnit (akci nelze zrušit).');

  };

  @action loadPDF = (id) => {
    SbToolProjectVersionService.downloadCertificate(id).then(resp => {
      if (resp.data) {
        this.setState({certificate: resp.data})
      }
    })
  }

  @action downloadPDF = () => {
    const {certificate} = this.state
    let projectVersion = SbToolProjectVersionService.projectVersion;

    if (certificate) {
      const url = window.URL.createObjectURL(new Blob([certificate]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download',
        'Certificate-' + projectVersion.project.name + '-ver.' + projectVersion.version + '.pdf');
      document.body.appendChild(link);
      link.click();
    }
  };

  private renderProjectInfoHeader = (): ReactNode => {
    let project: Project = SbToolProjectVersionService.projectVersion.project
    let {
      name, description, address, cadastralParcelNumber, cadastralParcelArea,
      documentationCreator, documentationCreated, documentationLevel, evaluator,
      buildingType, schoolLevel, documentationVersion, projectEvaluationFinished,
      estimatedCosts, anticipatedCommissioning, evaluationPhase, evaluationType, certified_person,
      projectCreated
    } = project

    function accentDataValue(value) {
      let textStyle = {
        color: "#666"
      }
      if (typeof value === "boolean") {
        return <span style={textStyle}>{value ? "Ano" : "Ne"}</span>
      } else if (typeof value === "object") {
        return <span style={textStyle}>{value.label ? value.label : '-'}</span>
      } else {
        return <span style={textStyle}>{value ? value : '-'}</span>
      }
    }

    return (
      <div
        style={{display: "flex", justifyContent: "space-around", color: "#9e9e9e", borderBottom: "1px solid #E7E7E7"}}>


        <ul style={{listStyle: "none"}}>
          <h5 style={{paddingBottom: 10, borderBottom: "1px solid grey"}}>Identifikační údaje projektu</h5>
          <li>Název projektu: {accentDataValue(name)}</li>
          <li>Místo stavby: {accentDataValue(address)}</li>
          <li>Katastrální území parcely: {accentDataValue(cadastralParcelArea)}</li>
          <li>Katastrální číslo parcely: {accentDataValue(cadastralParcelNumber)}</li>
          <li>Typologický druh: {accentDataValue(buildingType)} </li>
          {buildingType.value === 3 && <li>Stupeň vzdělání: {accentDataValue(schoolLevel)}</li>}
          <li>Popis: {accentDataValue(description)}</li>
          <li>Odhadované náklady (mil CZK): {accentDataValue(estimatedCosts)}</li>
          <li>Předpokládané uvedení stavby do provozu: {accentDataValue(anticipatedCommissioning)}</li>
        </ul>

        <ul style={{listStyle: "none"}}>
          <h5 style={{paddingBottom: 10, borderBottom: "1px solid grey"}}>Informace k projektové dokumentaci</h5>
          <li>Zpracovatel PD: {accentDataValue(documentationCreator)}</li>
          <li>Datum zpracování PD: {accentDataValue(documentationCreated)}</li>
          <li>Stupeň PD: {accentDataValue(documentationLevel)}</li>
          <li>Verze PD: {accentDataValue(documentationVersion)}</li>
        </ul>

        <ul style={{listStyle: "none"}}>
          <h5 style={{paddingBottom: 10, borderBottom: "1px solid grey"}}>Informace k hodnocení</h5>
          <li>Fáze hodnocení: {accentDataValue(evaluationPhase)}</li>
          <li>Typ hodnocení: {accentDataValue(evaluationType)}</li>
          <li>Hodnotitel SBToolCZ: {accentDataValue(evaluator)}</li>
          <li>Certifikovaná osoba: {accentDataValue(certified_person)}</li>
          <li>Datum založení projektu: {accentDataValue(projectCreated)}</li>
          <li>Datum dokončení procesu hodnocení: {accentDataValue(projectEvaluationFinished)}</li>
        </ul>

        <img
          src={this.state.image ? `data:image/png;base64,${this.state.image}` : `https://www.allianceplast.com/wp-content/uploads/no-image-1024x1024.png`}
          style={{objectFit: 'cover', width: 250, maxHeight: 250}}
          alt={'Project Image'}/>

      </div>
    )
  }
  @action handleUploadProjectImage = (files: FileList) => {
    const fileSize = files[0].size
    if (fileSize > 1048576) {
      alert(loc.i18n`Image Size Error`)
      return
    } else {
      let project: Project = SbToolProjectVersionService.projectVersion.project
      let data = new FormData();
      data.append("file", files.item(0), files.item(0).name);
      ProjectService.uploadProjectImage(project.projectId, data)
        .then(resp => {
          let importRes: ProjectImportResponse = resp.data as ProjectImportResponse;
          if (resp.status === 200) {
            ProjectService.getProjectImage(project.projectId).then(res => {
              console.log('fetch Project Image')
              if (res) {
                this.setState({image: res})
              }
            })
          }
          if (!importRes.importErrors || importRes.importErrors.length === 0) {
            return
          }
        }).catch(e => {
        console.error("error while import project image--->", e)
      })
    }


  };
  private renderTabs = (): ReactNode => {
    let projectVersion: ProjectVersion = SbToolProjectVersionService.projectVersion;
    if (projectVersion.$new) {
      return <noscript/>
    }

    return (
      <Tabs className="detail-grid" tabTemplate={TabTemplate} inkBarStyle={{transition: 'inherit'}}
            contentContainerStyle={{width: '100%', flexGrow: 1, display: 'flex', minHeight: 0}}
            onChange={this.onTabChange}>
        <Tab label={loc.i18n`Criteria`}
             style={TabStyles}
             key={CRITERIA_LIST}>
          <ProjectVersionParamsForm/>
        </Tab>
        <Tab style={TabStyles} label={loc.i18n`Methodological Tables`}>
          {this.state.isImportingMaterials ?
            <div style={{margin: 'auto', paddingTop: 20}}>
              <LoadingIcon/>
              <span style={{fontWeight: 700, fontSize: "36px", marginLeft: 20}}>Chvíli prosím počkejte. Probíhá import souborů</span>
            </div>
            :
            (<Tabs className="detail-grid" tabTemplate={TabTemplate} inkBarStyle={{transition: 'inherit'}}
                   style={{marginTop: "1rem"}}
                   contentContainerStyle={{width: '100%', display: 'flex', flexGrow: 1, minHeight: 0}}
                   onChange={this.onTabChange}>
              {this.renderGlobalMaterialsTab()}
              {this.renderLifespanTab()}
              {this.renderEnergyCarriersTab()}
              {this.renderRunoffCoefficientTab()}
            </Tabs>)}
        </Tab>
        <Tab style={TabStyles} label={loc.i18n`Project Data`}>
          {this.state.isImportingData ?
            <div style={{margin: 'auto', paddingTop: 20}}>
              <LoadingIcon/>
              <span style={{fontWeight: 700, fontSize: "36px", marginLeft: 20}}>Chvíli prosím počkejte. Probíhá import souborů</span>
            </div>
            :
            (<Tabs className="detail-grid" tabTemplate={TabTemplate} inkBarStyle={{transition: 'inherit'}}
                   style={{marginTop: "1rem"}}
                   contentContainerStyle={{width: '100%', display: 'flex', flexGrow: 1, minHeight: 0}}
                   onChange={this.onTabChange}>
              {this.renderCapacityTab()}
              {this.renderMaterialsTab()}
              {this.renderRoomsTab()}
              {this.renderAreasTab()}
              {this.renderWindowsTab()}
              {this.renderDoorsTab()}
              {this.renderLopFillingTab()}
              {this.renderLopsProfilesTab()}
              {this.renderParkingTab()}
              {this.renderTreesTab()}
            </Tabs>)
          }
        </Tab>

      </Tabs>)
  }
  submitDeleteDialogRefHandler = comp => this.modalWindow = comp;

  render() {
    return (
      <main className="main-content" style={{display: 'flex', flexDirection: 'column', padding: 20}}>
        <ConfirmationDialog ref={this.dirtyDialogRefHandler}/>
        <ConfirmationDialog ref={this.submitDeleteDialogRefHandler}/>
        <div>
          {this.renderToolTipMenu()}
          {this.renderProjectVersionForm()}
          {this.state.isProjectInfoOpen && this.renderProjectInfoHeader()}
        </div>
        <div style={{display: 'flex'}}>
          {this.renderTabs()}
        </div>

      </main>
    );
  }


}




// WEBPACK FOOTER //
// ./src/sbtool/page/project/projectVersionDetail.tsx